import { DollarSign } from "lucide-react";
import { formatPrice } from "../../pricing/pricingEngine";

/**
 * Shared Estimate Card — used across every service category wizard.
 *
 * Displays "Estimated Labor Cost" and shows a placeholder ("—") until
 * the customer has made priced selections. When `isCustomRequest` is true
 * (customer used the "Can't find what you need?" prompt without picking a
 * predefined service), the card shows a "Custom Request — Estimate Requires
 * Admin Review" note instead of a price.
 */
export const EstimateCard = ({ priceRange, subtitle = null, isCustomRequest = false }) => {
  const hasValidPrice =
    priceRange &&
    (priceRange.hasValidPrice === true ||
      (typeof priceRange.low === "number" &&
        typeof priceRange.high === "number" &&
        (priceRange.low > 0 || priceRange.high > 0)));

  return (
    <div
      className="mt-6 p-4 bg-gray-50 rounded-xl border border-gray-200"
      data-testid="estimate-card"
    >
      <div className="flex items-center gap-2 text-[#1F2933]/70 mb-1">
        <DollarSign className="w-4 h-4" />
        <span className="text-sm font-medium">Estimated Labor Cost</span>
      </div>
      {hasValidPrice ? (
        <p
          className="text-xl font-bold text-[#0FA3B1]"
          data-testid="estimate-value"
        >
          {formatPrice(priceRange.low)} – {formatPrice(priceRange.high)}
        </p>
      ) : isCustomRequest ? (
        <p
          className="text-base font-semibold text-[#0FA3B1]"
          data-testid="estimate-custom-request"
        >
          Custom Request — Estimate Requires Admin Review
        </p>
      ) : (
        <p
          className="text-xl font-bold text-[#1F2933]/40"
          data-testid="estimate-placeholder"
        >
          —
        </p>
      )}
      {subtitle && (
        <p className="text-xs text-[#1F2933]/50 mt-1">{subtitle}</p>
      )}
    </div>
  );
};

export default EstimateCard;
